import Vue from 'vue'

const prefixo = 'Rkm'

// Import Components.
import Alert from './components/Alert'
import Application from './components/Application'
import Area from './components/Area'
import Button from './components/Button'
import ButtonGroup from './components/ButtonGroup'
import Card from './components/Card'
import CardBody from './components/CardBody'
import CardFooter from './components/CardFooter'
import CardGroup from './components/CardGroup'
import CardText from './components/CardText'
import Col from './components/Col'
import Container from './components/Container'
import Content from './components/Content'
import ContentBody from './components/ContentBody'
import ContentHeader from './components/ContentHeader'
import DataTable from './components/DataTable'
import Divider from './components/Divider'
import Dropdown from './components/Dropdown'
import DropdownDivider from './components/DropdownDivider'
import DropdownItem from './components/DropdownItem'
import Form from './components/Form'
import FormCheckbox from './components/FormCheckbox'
import FormCheckboxGroup from './components/FormCheckboxGroup'
import FormDatepicker from './components/FormDatepicker'
import FormGroup from './components/FormGroup'
import FormInput from './components/FormInput'
import FormInputAutocomplete from './components/FormInputAutocomplete'
import FormRadio from './components/FormRadio'
import FormRadioGroup from './components/FormRadioGroup'
import FormSelect from './components/FormSelect'
import FormSelectOption from './components/FormSelectOption'
import FormSelectOptionGroup from './components/FormSelectOptionGroup'
import FormTextEditor from './components/FormTextEditor'
import FormTextarea from './components/FormTextarea'
import Icon from './components/Icon'
import InputGroup from './components/InputGroup'
import InputGroupAppend from './components/InputGroupAppend'
import InputGroupPrepend from './components/InputGroupPrepend'
import InputGroupText from './components/InputGroupText'
import Link from './components/Link'
import List from './components/List'
import ListGroup from './components/ListGroup'
import ListGroupItem from './components/ListGroupItem'
import Main from './components/Main'
import Modal from './components/Modal'
import NavItem from './components/NavItem'
import NavItemDropdown from './components/NavItemDropdown'
import Navbar from './components/Navbar'
import NavbarBrand from './components/NavbarBrand'
import NavbarNav from './components/NavbarNav'
import NavbarNavIcon from './components/NavbarNavIcon'
import Notification from './components/Notification'
import Overlay from './components/Overlay'
import Row from './components/Row'
import Sidebar from './components/Sidebar'
import SidebarList from './components/SidebarList'
import SidebarListGroup from './components/SidebarListGroup'
import SidebarListGroupItem from './components/SidebarListGroupItem'
import Tab from './components/Tab'
import Table from './components/Table'
import Tabs from './components/Tabs'
import Wizard from './components/Wizard'
import {TabContent} from 'vue-form-wizard'

// Register components.
Vue.component(`${prefixo}Alert`, Alert)
Vue.component(`${prefixo}Application`, Application)
Vue.component(`${prefixo}Area`, Area)
Vue.component(`${prefixo}ButtonGroup`, ButtonGroup)
Vue.component(`${prefixo}Button`, Button)
Vue.component(`${prefixo}CardBody`, CardBody)
Vue.component(`${prefixo}CardFooter`, CardFooter)
Vue.component(`${prefixo}CardGroup`, CardGroup)
Vue.component(`${prefixo}CardText`, CardText)
Vue.component(`${prefixo}Card`, Card)
Vue.component(`${prefixo}Col`, Col)
Vue.component(`${prefixo}Container`, Container)
Vue.component(`${prefixo}ContentBody`, ContentBody)
Vue.component(`${prefixo}ContentHeader`, ContentHeader)
Vue.component(`${prefixo}Content`, Content)
Vue.component(`${prefixo}DataTable`, DataTable)
Vue.component(`${prefixo}Divider`, Divider)
Vue.component(`${prefixo}DropdownDivider`, DropdownDivider)
Vue.component(`${prefixo}DropdownItem`, DropdownItem)
Vue.component(`${prefixo}Dropdown`, Dropdown)
Vue.component(`${prefixo}FormCheckboxGroup`, FormCheckboxGroup)
Vue.component(`${prefixo}FormCheckbox`, FormCheckbox)
Vue.component(`${prefixo}FormDatepicker`, FormDatepicker)
Vue.component(`${prefixo}FormGroup`, FormGroup)
Vue.component(`${prefixo}FormInputAutocomplete`, FormInputAutocomplete)
Vue.component(`${prefixo}FormInput`, FormInput)
Vue.component(`${prefixo}FormRadioGroup`, FormRadioGroup)
Vue.component(`${prefixo}FormRadio`, FormRadio)
Vue.component(`${prefixo}FormSelectOptionGroup`, FormSelectOptionGroup)
Vue.component(`${prefixo}FormSelectOption`, FormSelectOption)
Vue.component(`${prefixo}FormSelect`, FormSelect)
Vue.component(`${prefixo}FormTextEditor`, FormTextEditor)
Vue.component(`${prefixo}FormTextarea`, FormTextarea)
Vue.component(`${prefixo}Form`, Form)
Vue.component(`${prefixo}Icon`, Icon)
Vue.component(`${prefixo}InputGroupAppend`, InputGroupAppend)
Vue.component(`${prefixo}InputGroupPrepend`, InputGroupPrepend)
Vue.component(`${prefixo}InputGroupText`, InputGroupText)
Vue.component(`${prefixo}InputGroup`, InputGroup)
Vue.component(`${prefixo}Link`, Link)
Vue.component(`${prefixo}ListGroupItem`, ListGroupItem)
Vue.component(`${prefixo}ListGroup`, ListGroup)
Vue.component(`${prefixo}List`, List)
Vue.component(`${prefixo}Main`, Main)
Vue.component(`${prefixo}Modal`, Modal)
Vue.component(`${prefixo}NavItemDropdown`, NavItemDropdown)
Vue.component(`${prefixo}NavItem`, NavItem)
Vue.component(`${prefixo}NavbarBrand`, NavbarBrand)
Vue.component(`${prefixo}NavbarNavIcon`, NavbarNavIcon)
Vue.component(`${prefixo}NavbarNav`, NavbarNav)
Vue.component(`${prefixo}Navbar`, Navbar)
Vue.component(`${prefixo}Notification`, Notification)
Vue.component(`${prefixo}Overlay`, Overlay)
Vue.component(`${prefixo}Row`, Row)
Vue.component(`${prefixo}SidebarListGroupItem`, SidebarListGroupItem)
Vue.component(`${prefixo}SidebarListGroup`, SidebarListGroup)
Vue.component(`${prefixo}SidebarList`, SidebarList)
Vue.component(`${prefixo}Sidebar`, Sidebar)
Vue.component(`${prefixo}Tab`, Tab)
Vue.component(`${prefixo}Table`, Table)
Vue.component(`${prefixo}Tabs`, Tabs)
Vue.component(`${prefixo}WizardTab`, TabContent)
Vue.component(`${prefixo}Wizard`, Wizard)

// Import directives.
import Alpha from './directives/alpha'
import Number from './directives/number'
import Trim from './directives/trim'
import Uppercase from './directives/uppercase'
import {VBToggle, VBTooltip} from 'bootstrap-vue'

// Register directives.
Vue.directive(`${prefixo}Alpha`, Alpha)
Vue.directive(`${prefixo}Number`, Number)
Vue.directive(`${prefixo}Toggle`, VBToggle)
Vue.directive(`${prefixo}Tooltip`, VBTooltip)
Vue.directive(`${prefixo}Trim`, Trim)
Vue.directive(`${prefixo}Uppercase`, Uppercase)

// Import plugins
import {BVModalPlugin} from 'bootstrap-vue'
Vue.use(BVModalPlugin)